import { Input } from "antd";
import React, {useState} from "react";
import styled from "styled-components";
import { OpenEyeIcon, CloseEyeIcon } from "@assets";

const PasswordInput = styled(Input.Password)`
	height: 55px;
	&::placeholder {
		text-align: left;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		color: #9B92BB;
	}

	input {
		color: #342309 !important;
		text-align: left !important;
		font-size: 16px;
		font-style: normal;
		font-weight: 600;
		line-height: normal;
		background-color: #FFF !important;
	}

	&&& {
		border: none;
		border-radius: 12px;
		text-align: left !important;
		padding-left: 13px;
		color: #101415;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
	}
	background-color: #FFF !important;
`;

const InputPassword = ({value, placeholder, ...props }) => {
	const [isVisible, setIsVisible] = useState(false);

	const handleKeyDown = (event) => {
		const key = event.key;
		const isAllowedKey = /^[0-9\b]+$/.test(key);
		if (!isAllowedKey && key !== "Backspace") {
			event.preventDefault();
		}
	};

	const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

	const renderIcon = () => {
    return (
      <div style={{marginTop: 6}}>
       { 
        !value ? ''
          : isVisible ? <OpenEyeIcon onClick={toggleVisibility}/> 
          : <CloseEyeIcon onClick={toggleVisibility}/> 
        }
      </div>
    )
  }

	return (
		<PasswordInput
			size="large"
			placeholder={placeholder}
			onKeyDown={handleKeyDown}
			iconRender={renderIcon}
			{...props}
		/>
	);
};

export default InputPassword;
